/** Light Cycles client timing, in one place. */

/** The own cycle is extrapolated at most this far past the last confirmed tick. */
export const MAX_EXTRAPOLATE_TICKS = 1.5
/** A cycle whose next cell is blocked stops here inside its own cell until the crash frame arrives. */
export const BLOCKED_FRACTION = 0.5
/** A missed frame asks the server for a full snapshot, at most this often. */
export const SYNC_THROTTLE_MS = 1000
/** How long the crash spark burns, in ticks. */
export const SPARK_TICKS = 4
/** Predicted turns the server never confirmed are forgotten after this many ticks. */
export const MAX_PENDING_TICKS = 3
